/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../features/dashboard/segment/api/impl/Segment'
], function(
	Segment
) {
	return class InstrumentationUtil {
		/**
		* Calls the glass service directly to track a user action
		*
		* @param {object} The glass context
		* @param {string} The action to track
		* @param {object} Contains the context to track
		*/
		static track (glassContext, action, options = {}) {
			const instrumentationSvc =  glassContext.getCoreSvc('.Instrumentation');
			if (instrumentationSvc && instrumentationSvc.enabled) {
				let widgetsCount = {};
				let datasourcesCount = {};
				if (options.sources && options.sources.length > 0) {
					const dataSourceList = options.sources.map(source => {
						if (source.getType) {
							return source;
						} else {
							return {
								getType: () => source.type
							};
						}
					});
					datasourcesCount = Segment.getDataSourcesTypeCount(dataSourceList);
				}

				if (options.widgets && options.widgets.length > 0) {
					const widgetList = options.widgets.map(widget => {
						if (widget.getType) {
							return widget;
						} else {
							return {
								getType: () => widget.type
							};
						}
					});
					widgetsCount = Segment.getWidgetsTypeCount(widgetList);
				}

				const payload = {
					type: options.type,
					objectType: options.objectType,
					action: action,
					milestoneName: `${action}_${options.objectType}`,
					...datasourcesCount,
					...widgetsCount
				};

				if (options.object) {
					payload.object = options.object;
				}


				instrumentationSvc.track(payload);
			}
		}

		static trackWidget (action, dashboardApi, widgetSpec, widgetId) {
			let widgetType;
			let trackType;
			let widgetSource;
			let _widgetSpec = widgetSpec || {};
			if (action === 'deleted') {
				const canvasAPI = dashboardApi.getCanvas();
				const contentAPI = canvasAPI.getContent(widgetId);
				if (contentAPI) {
					if (contentAPI.getType() === 'widget.live') {
						trackType = 'data_widget';

						const stringResources = dashboardApi.getDashboardCoreSvc('.StringResources');
						const visualization = contentAPI.getFeature('Visualization');
						const error = contentAPI.getFeature('state').getError() || null;
						const params = error ? error.getParams() : null;
						const errorInfo = params ? params.errorInfo : null;

						widgetType = errorInfo ? errorInfo.id : (visualization.getDefinition() ? visualization.getDefinition().getType() : stringResources.get('one_unknown_live'));
					} else {
						trackType = 'nonData_widget';
						widgetType = contentAPI.getType();
					}
				}
			} else {
				widgetSource = this._getWidgetSource(widgetSpec);

				if(_widgetSpec.type === 'live') {
					trackType = 'data_widget';
					widgetType = this._getVisualizationTypeFromVisId(_widgetSpec.visId, dashboardApi) || _widgetSpec.name || _widgetSpec.type;
				} else {
					trackType = 'nonData_widget';
					widgetType =  _widgetSpec.subType || _widgetSpec.type;
				}
			}

			this._createPayload(widgetType, action, dashboardApi, _widgetSpec.visId, widgetId, trackType, widgetSource);
		}

		static _getWidgetSource(widgetSpec) {
			return widgetSpec.visTypeLocked ?  'manual' : 'fromRecommendation';
		}

		static _getVisualizationTypeFromVisId(visId, dashboardApi) {
			if (visId && dashboardApi){
				const VisDefinition =  dashboardApi.getFeature('VisDefinitions').getById(visId);
				return VisDefinition && VisDefinition.getType();
			}
			return  null;
		}

		static _createPayload (widgetType, action, dashboardApi, visId, widgetId, trackType, widgetSource) {
			if (widgetType) {
				const VisDefinition = dashboardApi.getFeature('VisDefinitions');
				let legacyWidgetType;
				if (VisDefinition) {
					legacyWidgetType = VisDefinition.getById(visId).getProperty('legacySegmentType');
				}
				widgetType = legacyWidgetType ? legacyWidgetType : widgetType;

				const callback = () => {
					const payload = {
						details: {
							widgetType: widgetType,
							assetType: dashboardApi.getApplicationName()
						},
						type: action === 'deleted' ? 'Deleted Object' : 'Created Object',
						trackType: trackType,
						widgetType: widgetType
					};

					if (widgetId) {
						payload.object = widgetId;
					}

					const assetId = dashboardApi.getDashboardInfo().boardId;
					if (assetId) {
						payload.details['assetId'] = assetId;
					}

					if (widgetSource) {
						payload.widgetSource = widgetSource; //'created'
						payload.details.widgetSource = widgetSource; //'created'
					}
					return payload;
				};

				const segment = dashboardApi.getFeature('segment');
				segment.track(action, callback);
			}
		}
	};
});
